import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import SettingSidebar from "../components/Setttingsidebar";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../App.css";
import { Pagination, Scrollbar, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { ApiUrl } from '../Constants/Weburl'
import Layout from "../components/Layout";
import CustomTable from "../components/CustomTable";
import CustomButton from "../components/CustomButton";
import CustomContainer from "../components/Customsettingscontain";
import useExpandableRows from "../components/useExpandableRows";
import useHiddenColumns from "../components/useHiddenFields";

export default function Hashtagdetails() {

    const [posts, setPosts] = useState([]);
    const [search, setSearch] = useState("");
    //   const [entries, setEntries] = useState(10);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(5);
    const [totalPages, setTotalPages] = useState(1);
    const [viewPost, setViewPost] = useState(null);
    const [isViewModalOpen, setIsViewModalOpen] = useState(false);

    const navigate = useNavigate();

    const { tag } = useParams();

    // console.log("hashtag", tag);

    const { toggleExpand, isExpanded } = useExpandableRows();

    const sampleReports = [
        {
            id: 1,
            reasonTitle: "Spam or misleading",
            reasons: "gderg",
            user: 'uma',
            description: 'good',
            date: "02 Dec 2025"
        },
    ]

    const headers = [
        { label: "Content", className: 'pt-col-content' },
        { label: "Type", className: 'pt-col-type', field: "type" },
        { label: "User", className: 'pt-col-user', field: "user" },
        { label: "Description & Stats", className: 'pt-col-desc col-hide-3', field: "desc" },
        { label: "Created Date", className: 'pt-col-date col-hide-2', field: "date" },
        { label: "Action", className: 'pt-col-action col-hide-1', field: "action" },
    ]

    const hiddenFields = useHiddenColumns(".rr1-table", headers);

    useEffect(() => {
        fetchPostHashtag();
    }, [tag, page, limit, search]);

    const fetchPostHashtag = async () => {
        try {
            const token = localStorage.getItem("adminToken");

            const cleanTag = tag.replace('#', '').toLowerCase();

            console.log("Fetching posts for hashtag:", tag);

            const response = await axios.get(`${ApiUrl}api/auth/hashtag/${cleanTag}?page=${page}&limit=${limit}&search=${search}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            setPosts(response.data.posts);

            console.log("response fetchposthashtag", response.data);
        } catch (error) {
            console.log('Error loading hashtag posts:', error.message);
        }
    }

    //delete hashtagdetails
    const handleDeletePost = async (id) => {
        try {
            const token = localStorage.getItem("adminToken");

            const res = await axios.delete(
                `${ApiUrl}api/auth/hashtag/delete/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            console.log("res delete hashtag", res.data);

            setPosts(posts.filter(post => post.id !== id));

        } catch (err) {
            console.error(err);
            alert("Delete failed");
        }
    };

    const getImageUrl = (img) => {
        if (!img) return "";
        if (img.startsWith("http")) return img;
        return `${ApiUrl}${img.replace("\\", "/")}`;
    };

    const handleViewContent = (post) => {
        setViewPost(post);
        setIsViewModalOpen(true);
    };

    return (
        <div className="layout">
            <Layout>

                <CustomContainer className="rr-wrapperhashtag">
                    <div className="ht-header-bar">
                        <h3 className="ht-page-title">Hashtags</h3>
                        {/* <h3>#{tag}</h3>
                        <h6>Total Posts:{posts.length}</h6> */}
                        <div className="hashtag-summary-card ht-add-btn">
                            <div className="hashtag-icon">
                                {/* <i className="bi bi-file-earmark-text"></i> */}
                                <i class="bi bi-hash"></i>
                            </div>

                            <div className="hashtag-summary-content">
                                <h2>{tag}</h2>

                                <div className="hashtag-post-count">
                                    <span className="post-count-icon">
                                        <i className="bi bi-file-earmark-text"></i>
                                        <span>{posts.length}</span>
                                    </span>

                                    <span className="total-posts-text">
                                        Total Posts
                                    </span>
                                </div>
                            </div>
                        </div>


                        <div className="ht-header-right">
                            <div className="rr-left">
                                Show
                                <select
                                    className="rr-select"
                                    value={limit}
                                    // onChange={(e) => setEntries(Number(e.target.value))}>
                                    onChange={(e) => {
                                        setLimit(Number(e.target.value));
                                        setPage(1); // reset page
                                    }}
                                >
                                    <option>5</option>
                                    <option>10</option>
                                    <option>25</option>
                                    <option>50</option>
                                </select>
                                entries
                            </div>

                            <div className="rr-right">
                                <span>Search:</span>
                                <input
                                    className="rr-search"
                                    type="text"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    placeholder="Search hashtag"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="rr-card">
                        <CustomTable className="rr1-table posts-table" headers={headers}>

                            {/* <tbody > */}
                            {posts.map((item, idx) => (
                                <React.Fragment key={item.id ?? idx}>
                                    <tr className="rr-actionshastag">
                                        {/* <td className="rr-actions1">{item.hashtag}</td> */}
                                        {/* <td className="rr-actions1">{item.reasonTitle}</td> */}
                                        <td className="profile-pill">
                                            {hiddenFields.length > 0 && (
                                                <button
                                                    type="button"
                                                    className={`row-expand-toggle ${isExpanded(item.id ?? idx) ? "is-open" : ""}`}
                                                    onClick={() => toggleExpand(item.id ?? idx)}
                                                    aria-label="Show more details"
                                                >
                                                    {isExpanded(item.id ?? idx) ? "−" : "+"}
                                                </button>

                                            )}
                                            <button
                                                className="view-btn"
                                                onClick={() => handleViewContent(item)}
                                            >
                                                <i className="bi bi-play" style={{ fontSize: '20px' }}></i> View Content
                                            </button>
                                        </td>
                                        <td className="pt-col-type">
                                            <span className="real-badge">{item.postType}</span></td>
                                        <td className="pt-col-user">
                                            <div className="profile-pill">
                                                <div className="avatar">
                                                    <img
                                                        src={getImageUrl(item?.user?.avatar)}
                                                        alt=""
                                                        style={{
                                                            width: 40,
                                                            height: 40,
                                                            borderRadius: "50%",
                                                        }}
                                                    />
                                                </div>
                                                <div>
                                                    <div className="username">{item?.user?.username}</div>
                                                    <div className="subtext">{item?.user?.name}</div>
                                                </div>
                                            </div>
                                        </td>

                                        <td className="pt-col-desc rr-actions4 col-hide-3">

                                            <div className="likecommentsposts">

                                                <div className="likecommentsdesign">

                                                    <span className="allspan">
                                                        <i class="bi bi-suit-heart" ></i><span>:</span>{item.like_posts.length}</span>

                                                </div>

                                                <div className="likecommentsdesign">

                                                    <span className="allspan">
                                                        <i class="bi bi-chat"></i>
                                                        <span>:</span>
                                                        {item.comments.length}
                                                    </span>

                                                </div>

                                                <div className="likecommentsdesign">

                                                    <span className="allspan"><i class="bi bi-bookmark"></i><span>:</span>{item.save_posts.length}</span>

                                                </div>
                                                <div className="likecommentsdesign">

                                                    <span className="allspan"><i class="bi bi-share"></i><span>:</span>{item.share_posts.length}</span>

                                                </div>
                                            </div>

                                            {/* <h5 className="reason-title">{posts.title}</h5> */}
                                            <p className="alldescriptiontext">{item.description}</p>
                                        </td>



                                        <td className="pt-col-date rr-actions5 col-hide-2">{new Date(item.createdAt).toLocaleDateString("en-IN")}</td>
                                        <td className="pt-col-action rr-actionsbutton col-hide-1">
                                            <CustomButton
                                                className="rr-icon-btn green"
                                                onClick={() => navigate(`/PostView/${item.id}`)}
                                            >
                                                <i class="bi bi-eye"></i>
                                            </CustomButton>

                                            <CustomButton
                                                className="rr-icon-btn red"
                                                onClick={() => handleDeletePost(item.id)}
                                            >
                                                <i className="bi bi-trash"></i>
                                            </CustomButton>
                                        </td>
                                    </tr>

                                    {isExpanded(item.id ?? idx) && hiddenFields.length > 0 && (
                                        <tr className="row-expand-details">
                                            <td colSpan={6}>
                                                <div className="expand-details">
                                                    {hiddenFields.map(({ field, label }) => (
                                                        <div className="expand-item" key={field}>
                                                            <span className="expand-label">{label}</span>
                                                            {field === "type" && (
                                                                <span className="real-badge">{item.postType}</span>
                                                            )}
                                                            {field === "user" && (
                                                                <div className="profile-pill">
                                                <div className="avatar">
                                                    <img
                                                        src={getImageUrl(item?.user?.avatar)}
                                                        alt=""
                                                        style={{
                                                            width: 40,
                                                            height: 40,
                                                            borderRadius: "50%",
                                                        }}
                                                    />
                                                </div>
                                                <div>
                                                    <div className="username">{item?.user?.username}</div>
                                                    <div className="subtext">{item?.user?.name}</div>
                                                </div>
                                            </div>
                                                            )}
                                                            {field === "desc" && (
                                                                <div>
                                                                     <div className="likecommentsposts">

                                                <div className="likecommentsdesign">

                                                    <span className="allspan">
                                                        <i class="bi bi-suit-heart" ></i><span>:</span>{item.like_posts.length}</span>

                                                </div>

                                                <div className="likecommentsdesign">

                                                    <span className="allspan">
                                                        <i class="bi bi-chat"></i>
                                                        <span>:</span>
                                                        {item.comments.length}
                                                    </span>

                                                </div>

                                                <div className="likecommentsdesign">

                                                    <span className="allspan"><i class="bi bi-bookmark"></i><span>:</span>{item.save_posts.length}</span>

                                                </div>
                                                <div className="likecommentsdesign">

                                                    <span className="allspan"><i class="bi bi-share"></i><span>:</span>{item.share_posts.length}</span>

                                                </div>
                                            </div>

                                            {/* <h5 className="reason-title">{posts.title}</h5> */}
                                            <p className="alldescriptiontext">{item.description}</p>
                                                                </div>
                                                            )}
                                                            {field === "date" && (
                                                                <span className="expand-value">
                                                                    {new Date(item.createdAt).toLocaleDateString("en-IN")}
                                                                </span>
                                                            )}
                                                            {field === "action" && (
                                                                <div style={{ display: "flex", gap: 8 }}>
                                                                   <CustomButton
                                                className="rr-icon-btn green"
                                                onClick={() => navigate(`/PostView/${item.id}`)}
                                            >
                                                <i class="bi bi-eye"></i>
                                            </CustomButton>

                                            <CustomButton
                                                className="rr-icon-btn red"
                                                onClick={() => handleDeletePost(item.id)}
                                            >
                                                <i className="bi bi-trash"></i>
                                            </CustomButton>
                                                                </div>
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            ))}
                            {/* </tbody> */}
                        </CustomTable>

                        <div className="rr-footer">

                            <span>
                                Showing 1 to {posts.length} of {posts.length} entries
                            </span>


                            <div className="rr-pagination">

                                <>
                                    <span
                                        className="rr-page-arrow"
                                        onClick={() => page > 1 && setPage(page - 1)}
                                    >
                                        &lt;
                                    </span>

                                    {/* {[...Array(totalPages)].map((_, i) => ( */}
                                    {Array.from({ length: totalPages || 0 }).map((_, i) => (

                                        <span
                                            key={i}
                                            className="rr-page"
                                            onClick={() => setPage(i + 1)}
                                        >
                                            {i + 1}
                                        </span>
                                    ))}

                                    <span
                                        className="rr-page-arrow"
                                        onClick={() => page < totalPages && setPage(page + 1)}
                                    >
                                        &gt;
                                    </span>
                                </>



                            </div>
                        </div>

                        {isViewModalOpen && viewPost && (
                            <div className="modal-overlay">
                                <div className="modal-box">
                                    <div>
                                        <button
                                            className="close-btn"
                                            onClick={() => setIsViewModalOpen(false)}
                                        >
                                            ✕
                                        </button>

                                        <h3 style={{ marginTop: "-5px" }}>View Content</h3>
                                    </div>

                                    {viewPost.text && <p>{viewPost.text}</p>}

                                    <h3>
                                        {viewPost.hashtags
                                            ? JSON.parse(viewPost.hashtags).map((tag) => `#${tag}`).join(" ")
                                            : ""}
                                    </h3>

                                    {viewPost.mentions && (
                                        <p>
                                            {JSON.parse(viewPost.mentions).map((m) => `@${m}`).join(" ")}
                                        </p>
                                    )}

                                    {/* ---- POST CONTENT (SWIPER) ---- */}
                                    <div className="content-preview" style={{ width: "100%" }}>
                                        {(() => {
                                            if (!viewPost.files) return <p>No media</p>;

                                            const files = JSON.parse(viewPost.files);

                                            return (
                                                <Swiper spaceBetween={10} slidesPerView={1} modules={[Pagination, Scrollbar, A11y]}
                                                    navigation
                                                    pagination={{ clickable: true }}
                                                    scrollbar={{ draggable: true }}
                                                    onSwiper={(swiper) => console.log(swiper)}
                                                    onSlideChange={() => console.log('slide change')}

                                                >
                                                    {files.map((file, index) => {
                                                        const fileUrl = `${ApiUrl}${file.uri.replace(
                                                            /\\/g,
                                                            "/"
                                                        )}`;

                                                        return (
                                                            <SwiperSlide key={index}>
                                                                {file.type?.includes("image") ? (
                                                                    <img
                                                                        src={fileUrl}
                                                                        style={{
                                                                            width: "100%",
                                                                            height: "400px",
                                                                            objectFit: "cover",
                                                                            borderRadius: 10,
                                                                        }}
                                                                    />
                                                                ) : file.type?.includes("video") ? (
                                                                    <video
                                                                        src={fileUrl}
                                                                        controls
                                                                        style={{
                                                                            width: "100%",
                                                                            height: "400px",
                                                                            objectFit: "contain",
                                                                            borderRadius: 10,
                                                                        }}
                                                                    />
                                                                ) : null}
                                                            </SwiperSlide>
                                                        );
                                                    })}
                                                </Swiper>
                                            );
                                        })()}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                </CustomContainer>

            </Layout>
        </div>
    );
}

